// src/pages/EditApartmentPage.js
import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Grid,
    Button,
    MenuItem,
    Typography,
    Paper,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { vendorApi } from "../../../api/api";
import { useSelector } from "react-redux";
import GradientButton from "../../common/GradiantButton";
import SecondaryButton from "../../common/SecondaryButton";

const EditApartmentPlotsDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const apartment = location.state?.apartmentData || {}; 
    const rawData = apartment?.[0];
    const theme = useSelector((data) => data.themeValue.colors);
    const [formData, setFormData] = useState(() => {
        if (!rawData) {
            return {
            
                ApartmentName: "",
                PlotName: "",
                Address: "",
                City: "",
                Bedrooms: "",
                Bathrooms: "",
                Balcony: "",
                TotalFloors: "",
                CCTVAvailable: false,
                GatedSecurity: false,
                LiftAvailable: false,
                ParkingAvailable: false,
                ParkingType: "",
                PowerBackUp: "",
                WaterSupply: "",
                MaintenanceCharges: "",
                Facing: "",
                AgeOfBuilding: "",
                SizeInSqFt: "",
                LandArea: "",
                MarketPrice: "",
                GeoLocation: "",

            };
        }

        const extra = rawData.Amenities || {};
      

        return {
            ApartmentName: rawData.ApartmentName || "",
            PlotName: rawData.PlotName || "",
            Address: rawData.Address || "",
            City: rawData.City || "",
            Bedrooms: extra.Bedrooms || "",
            Bathrooms: extra.Bathrooms || "",
            Balcony: extra.Balcony || "",
            TotalFloors: rawData.TotalFloors || "",
            CCTVAvailable: extra.CCTVAvailable === "yes",
            GatedSecurity: extra.GatedSecurity === "yes",
            LiftAvailable: extra.LiftAvailable === "yes",
            ParkingAvailable: extra.ParkingAvailable === "yes",
            ParkingType: extra.ParkingType || "",
            PowerBackUp: extra.PowerBackUp || "",
            WaterSupply: extra.WaterSupply || "",
            MaintenanceCharges: extra.MaintenanceCharges || "",
            Facing: rawData.Facing || "",
            AgeOfBuilding: extra.AgeOfBuilding || "",
            SizeInSqFt: rawData.SizeInSqFt || "",
            LandArea: rawData.LandArea || "",
            MarketPrice: rawData.MarketPrice || "",
            GeoLocation: rawData.GeoLocation || "",

        };
    });
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            "Id":rawData.Id,
            
            "ApartmentName": formData.ApartmentName,
            "PlotName": formData.PlotName,
            "Address": formData.Address,
            "City": formData.City,
            "Facing": formData.Facing,
            "LandArea": formData.LandArea,
            "TotalPrice": 3000,
            "SizeInSqFt": formData.SizeInSqFt,
            "TotalFloors": formData.TotalFloors,
            "GeoLocation": formData.GeoLocation,

            "Amenities": {
                "Bedrooms": formData.Bedrooms,
                "Bathrooms": formData.Bathrooms,
                "Balcony": formData.Balcony,
                "AgeOfBuilding": formData.AgeOfBuilding,
                "ParkingType": formData.ParkingType,
                "PowerBackUp": formData.PowerBackUp,
                "WaterSupply": formData.WaterSupply,
                "MaintenanceCharges": formData.MaintenanceCharges,
                "CCTVAvailable": formData.CCTVAvailable,
                "GatedSecurity": formData.GatedSecurity,
                "LiftAvailable": formData.LiftAvailable,
                "ParkingAvailable": formData.ParkingAvailable
            }
        }


        try {
            
            const response = await vendorApi.editApartmentDetails(payload);
            alert(" Success Update");
        } catch (err) {
            console.error(" Submission error:", err.response?.data || err);
            alert("Error updating apartment — check console.");
        }
    };

    // Options for dropdown fields
    const parkingTypes = ["car","bike","both"];

    return (
        <Box sx={{ maxWidth: "95%", mx: "auto", mt: 4 }}>
            <Paper sx={{ p: 3, backgroundColor: theme.background }}>
                <Typography variant="h5" gutterBottom sx={{ color: theme.text }}>
                    Edit Details
                </Typography>

                <Box component="form"  sx={{ paddingTop: "20px" }}>
                    <Grid container spacing={2} sx={{ width: "100%", textAlign: "center", display: "flex", justifyContent: "center" }}>
                        {/* Basic Info */}
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',   // Extra-small devices (phones)
                                sm: '80%',    // Small devices (tablets)
                                md: '45%',    // Medium devices (desktops)
                                lg: '45%',    // Large devices and up
                            },
                        }}>
                            <TextField
                                name="ApartmentName"
                                label="Apartment Name"
                                fullWidth
                                value={formData.ApartmentName}
                                onChange={handleChange}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="PlotName"
                                label="Plot Name"
                                fullWidth
                                value={formData.PlotName}
                                onChange={handleChange}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        {/* Address */}
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="Address"
                                label="Address"
                                fullWidth
                                value={formData.Address}
                                onChange={handleChange}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="City"
                                label="City"
                                fullWidth
                                value={formData.City}
                                onChange={handleChange}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        {/* Room Details */}
                        <Grid xs={12} sm={3} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="Bedrooms"
                                label="Bedrooms"
                                type="number"
                                fullWidth
                                value={formData.Bedrooms}
                                onChange={handleChange}
                                inputProps={{ min: 1 }}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={3} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="Bathrooms"
                                label="Bathrooms"
                                type="number"
                                fullWidth
                                value={formData.Bathrooms}
                                onChange={handleChange}
                                inputProps={{ min: 1 }}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={3} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="Balcony"
                                label="Balcony"
                                type="number"
                                fullWidth
                                value={formData.Balcony}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={3} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="TotalFloors"
                                label="Total Floors"
                                type="number"
                                fullWidth
                                value={formData.TotalFloors}
                                onChange={handleChange}
                                inputProps={{ min: 1 }}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>




                        {/* Amenities - Dropdowns */}
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                                textAlign: "start"
                            },
                        }}>
                            <TextField
                                select
                                name="ParkingType"
                                label="Parking Type"
                                fullWidth
                                value={formData.ParkingType}
                                onChange={handleChange}
                                sx={{
                                    // Label color (default and focused)
                                    '& .MuiInputLabel-root': {
                                        color: theme.text,
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: theme.primary_color,
                                    },

                                    // Select input (selected value)
                                    '& .MuiSelect-select': {
                                        color: theme.text,
                                    },

                                    // Border colors
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            >
                                {parkingTypes.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                                textAlign: "start"
                            },
                        }}>
                            <TextField

                                name="PowerBackUp"
                                label="Power Backup"
                                fullWidth
                                value={formData.PowerBackUp}
                                onChange={handleChange}
                                sx={{
                                    // Label color (default and focused)
                                    '& .MuiInputLabel-root': {
                                        color: theme.text,
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: theme.primary_color,
                                    },

                                    // Select input (selected value)
                                    '& .MuiSelect-select': {
                                        color: theme.text,
                                    },

                                    // Border colors
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            >
                               
                            </TextField>
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                                textAlign: "start"
                            },
                        }}>
                            <TextField
                                
                                name="WaterSupply"
                                label="Water Supply"
                                fullWidth
                                value={formData.WaterSupply}
                                onChange={handleChange}
                                sx={{
                                    // Label color (default and focused)
                                    '& .MuiInputLabel-root': {
                                        color: theme.text,
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: theme.primary_color,
                                    },

                                    // Select input (selected value)
                                    '& .MuiSelect-select': {
                                        color: theme.text,
                                    },

                                    // Border colors
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            >
                                
                            </TextField>
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="MaintenanceCharges"
                                label="Maintenance Charges (₹)"
                                type="number"
                                fullWidth
                                value={formData.MaintenanceCharges}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        {/* Property Details */}
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                                textAlign: "start"
                            },
                        }}>
                            <TextField
                                name="Facing"
                                label="Facing"
                                fullWidth
                                value={formData.Facing}
                                onChange={handleChange}
                                sx={{
                                    // Label color (default and focused)
                                    '& .MuiInputLabel-root': {
                                        color: theme.text,
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: theme.primary_color,
                                    },

                                    // Select input (selected value)
                                    '& .MuiSelect-select': {
                                        color: theme.text,
                                    },

                                    // Border colors
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            >
                               
                            </TextField>
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="AgeOfBuilding"
                                label="Age of Building (years)"
                                type="number"
                                fullWidth
                                value={formData.AgeOfBuilding}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="SizeInSqFt"
                                label="Size (Sq. Ft.)"
                                type="number"
                                fullWidth
                                value={formData.SizeInSqFt}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="LandArea"
                                label="Land Area (Sq. Ft.)"
                                fullWidth
                                value={formData.LandArea}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '92%',
                                lg: '92%',
                            },
                        }}>
                            <TextField
                                name="MarketPrice"
                                label="Market Price (₹)"
                                type="number"
                                fullWidth
                                disabled
                                value={formData.MarketPrice}
                                onChange={handleChange}
                                inputProps={{ min: 0 }}
                                required
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid>
                        {/* <Grid xs={12} sm={6} sx={{
                            width: {
                                xs: '100%',
                                sm: '80%',
                                md: '45%',
                                lg: '45%',
                            },
                        }}>
                            <TextField
                                name="GeoLocation"
                                label="Geo Location"
                                fullWidth
                                value={formData.GeoLocation}
                                onChange={handleChange}
                                placeholder="latitude,longitude"
                                sx={{
                                    // mb: 3,
                                    input: {
                                        color: theme.text,
                                    },
                                    label: {
                                        color: theme.text,
                                    },
                                    '& label.Mui-focused': {
                                        color: theme.primary_color,
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: theme.text,
                                        },
                                        '&:hover fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: theme.primary_color,
                                        },
                                    },
                                }}
                            />
                        </Grid> */}
                        <Grid container spacing={2} sx={{ mb: 2, width: "100%", display: "flex", justifyContent: "center" }}>
                            {[
                                { name: "CCTVAvailable", label: "CCTV Available" },
                                { name: "GatedSecurity", label: "Gated Security" },
                                { name: "LiftAvailable", label: "Lift Available" },
                                { name: "ParkingAvailable", label: "Parking Available" },
                            ].map((item) => (
                                <Grid xs={6} sm={3} key={item.name} sx={{
                                    width: {
                                        xs: '100%',
                                        sm: '80%',
                                        md: '45%',
                                        lg: '45%',
                                        textAlign: "start"
                                    },
                                }}>
                                    <TextField
                                        select
                                        name={item.name}
                                        label={item.label}
                                        value={formData[item.name] ? "yes" : "no"}
                                        onChange={(e) => {
                                            setFormData(prev => ({
                                                ...prev,
                                                [item.name]: e.target.value === "yes"
                                            }));
                                        }}
                                        fullWidth
                                        variant="outlined"
                                        
                                        sx={{
                                            // Label color (default and focused)
                                            '& .MuiInputLabel-root': {
                                                color: theme.text,
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: theme.primary_color,
                                            },

                                            // Select input (selected value)
                                            '& .MuiSelect-select': {
                                                color: theme.text,
                                            },

                                            // Border colors
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: theme.text,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: theme.primary_color,
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: theme.primary_color,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="yes">Yes</MenuItem>
                                        <MenuItem value="no">No</MenuItem>
                                    </TextField>
                                </Grid>
                            ))}
                        </Grid>

                    </Grid>


                    <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
                        <SecondaryButton onClick={() => navigate("/profile/properties")}
                        text="Cancel"
                        width={{md:"15%" ,xs:"30%"}}/>
                        <GradientButton text="Save Changes"
                        onClick={handleSubmit}
                        width={{md:"15%" ,xs:"50%"}}/>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default EditApartmentPlotsDetails;